import React, { Component } from 'react'
import Link from 'gatsby-link'
import { CSSTransition } from 'react-transition-group'

import Menu from '../menu'
import Circle from '../../components/svgs/circle'
import './style.sass'

export default class Nav extends Component {
  state = { isMenuVisible: false }

  toggleMenu = () => {
    this.setState({ isMenuVisible: !this.state.isMenuVisible }, () => {
      if (this.state.isMenuVisible) {
        return (document.body.style.overflow = 'hidden')
      }

      document.body.style.overflow = 'auto'
    })
  }

  render() {
    const { visible } = this.props

    return (
      <div>
        <div className={`Nav ${visible ? 'Nav--visible' : ''}`}>
          <button
            className={
              'hamburger hamburger--slider ' +
              (this.state.isMenuVisible ? 'is-active' : '')
            }
            type="button"
            onClick={this.toggleMenu}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>

          <Link className="Nav__HomeLink" to="/">
            <Circle />
          </Link>

          {/* Elemento vuoto per far tornare la distribuzione dello 
        spazio degli elementi con Flex */}
          <div style={{ width: '50px' }}>&nbsp;</div>
        </div>

        <CSSTransition
          in={this.state.isMenuVisible}
          timeout={200}
          classNames="Nav__MenuContainer"
          unmountOnExit
        >
          <Menu onLinkClick={this.toggleMenu} />
        </CSSTransition>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/nav/index.js